import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "bordered-card w-100 mt-20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Documents Currently On File/Pending Admin Preview", -1)
const _hoisted_7 = { class: "small mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " No documents have been uploaded to your account. ")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "action-buttons pdt-100 w-100 d-flex justify-content-between" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_DragDrop = _resolveComponent("DragDrop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: `<p>
                In order to enroll in Plan C Medical Reimbursement Program you must send us a front and back copy of your other employer or union sponsored group health coverage identification card.  <br>
                <strong> Please be careful when choosing and uploading documents for your MRP enrollment.  Make certain your submission is complete, accurate and all required documents are uploaded before clicking the submit button.  Once you click the submit button you will be prohibited from submitting additional or corrected documents.  Once our staff has completed reviewing your request you will receive an email letting you know to login and visit your dashboard for further updates regarding your enrollment selection.</strong>
            </p>
            <p>
                <strong>Please note:</strong>This website supports the following common file types: PDF, JPG, PNG, TIF, TIFF, BMP, GIF, WMF, EMF, PSD, WBMP, TLA, PCX, TGA. 
                File types not listed are unsupported and hence will not be processed.
            </p>`,
      classes: "info_card_full"
    }, null, 8, ["message"]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_SelectComponent, {
                  label: "Choose Document Type",
                  selectedOption: $setup.selectedDocType,
                  "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedDocType) = $event)),
                  options: $setup.documentTypes,
                  customClass: "full-width mt-20"
                }, null, 8, ["selectedOption", "options"]),
                _createVNode(_component_DragDrop, {
                  customClasses: "grey large w-100 mt-20",
                  onUpdateFiles: $setup.handleFileSelection,
                  reset: $setup.reset,
                  accept: ".pdf, .jpg, .jpeg, .png, .tif, .tiff, .bmp, .gif, .wmf, .emf, .psd, .wbmp, .tla, .pcx, .tga",
                  loading: $setup.loadingUpload,
                  key: "drag-drop-mrp"
                }, null, 8, ["onUpdateFiles", "reset", "loading"]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("table", _hoisted_7, [
                    _hoisted_8,
                    ($setup.uploadedDocs?.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.uploadedDocs, (document) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: document.DocumentID
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: "javascript;",
                                  onClick: _withModifiers(($event: any) => ($setup.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document?.DocumentID, FilePreview: document?.DocumentID, Type: 'dependent' })), ["prevent"])
                                }, _toDisplayString(document.Description), 9, _hoisted_10)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(document.EffectiveDate), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass({ 'text-danger': document.Status === 'Pending' })
                              }, _toDisplayString(document.Status), 3)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_11, _hoisted_13))
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    disabled: $setup.loadingUpload
                  }, " Back ", 8, _hoisted_15),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args))),
                    disabled: $setup.loadingUpload || !$setup.documentUploaded
                  }, " Submit ", 8, _hoisted_16)
                ])
              ])
            ])
          ])
        ]))
  ], 64))
}